import styled from "styled-components";

export const ModalContainer = styled.div`
    display: flex;
`;

export const ModalContainerLft = styled.div`
    width: 340px;
    flex-shrink: 0;
    background: linear-gradient(180deg, #F9FCFD 30%, #C5EDFD 70%);
    padding-top: 130px;
    padding-bottom: 30px;
    overflow: hidden;
    border-radius: 8px 0 0 8px;
`;

export const ModalContainerRht = styled.div`
    flex: 1;
    padding: 60px 30px 30px 30px;
    h3{
        font-size: 26px;
        line-height: 32px;
        color: #000;
        font-weight: 900;
        margin-bottom: 30px;
    }
`;